/**
 * 微存储【lun ---> namespace】
 */
 export const lunToNamespaceMap = {
    // 查询主机Namespace ID接口 hostNamespaceInfo
    AVAILABLEHOSTLUNIDLIST: 'AVAILABLEHOSTNAMESPACEIDLIST',
    lunGroupId: 'namespaceGroupId',
    lunGroupName: 'namespaceGroupName',
    lunId: 'namespaceId',
    lunName: 'namespaceName',
    hostLunID: 'hostNamespaceID',
    // 批量创建Namespace组关联 namespacegroup/associate/batch
    hostLunId: 'hostNamespaceId',
    startHostLunId: 'startHostNamespaceId',
    // 批量查询Namespace组
    lunNumber: 'namespaceNumber',
    // 查询Namespace组
    ASSOCIATELunIDLIST: 'ASSOCIATENamespaceIDLIST',
    // 创建映射
    hostLunIdStart: 'hostNamespaceIdStart',
    // 创建LUN组
    existLunIDs: 'existNamespaceIDs',
    newLunsInfo: 'newNamespacesInfo',

    // 批量查询namespace
    ISADD2LUNGROUP: 'ISADD2NAMESPACEGROUP',
};

/**
 * 微存储【namespace ---> lun】
 */
export const namespaceToLunMap = {
    // 查询主机Namespace ID接口 hostNamespaceInfo
    AVAILABLEHOSTNAMESPACEIDLIST: 'AVAILABLEHOSTLUNIDLIST',
    namespaceGroupId: 'lunGroupId',
    namespaceGroupName: 'lunGroupName',
    namespaceId: 'lunId',
    namespaceName: 'lunName',
    hostNamespaceID: 'hostLunID',
    // 批量创建Namespace组关联 namespacegroup/associate/batch
    hostNamespaceId: 'hostLunId',
    startHostNamespaceId: 'startHostLunId',
    // 批量查询Namespace组
    namespaceNumber: 'lunNumber',
    // 查询Namespace组
    ASSOCIATENamespaceIDLIST: 'ASSOCIATELunIDLIST',
    // 查询pms_lun
    namespace_name: 'lun_name',
    namespace_id: 'lun_id',
    namespace_capacity: 'lun_capacity',
    available_namespace_capacity: 'available_lun_capacity',
    // 查询容量预测数据
    namespacemap_existing_data: 'lunmap_existing_data',
    namespacemap_forecast_data: 'lunmap_forecast_data',
    namespace_mapped_capacity: 'lun_mapped_capacity',

    // 查询主机、查询主机组
    mappingNamespaceNumber: 'mappingLunNumber',

    // 批量查询Namespace
    ISADD2NAMESPACEGROUP: 'ISADD2LUNGROUP',

    // 批量查询存储池
    namespaceSpaceReductionRate: 'lunSpaceReductionRate',
    NAMESPACECONFIGEDCAPACITY: 'LUNCONFIGEDCAPACITY',
    NAMESPACEMAPPEDCAPACITY: 'LUNMAPPEDCAPACITY',
    NAMESPACEPROVISIONSAVEPERCENTAGE: 'THINPROVISIONSAVEPERCENTAGE',
    TOTALNAMESPACEWRITECAPACITY: 'TOTALLUNWRITECAPACITY',
};
